import { Link } from 'react-router-dom';
import { allVideos } from '@/mocks/data';

export default function FeaturedGrid() {
  const hotVideos = allVideos.filter((v) => v.isHot).slice(0, 8);
  const newVideos = allVideos.filter((v) => v.isNew).slice(0, 8);

  const VideoCard = ({ video }: { video: typeof allVideos[0] }) => (
    <Link
      to={`/article/${video.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-video rounded-lg overflow-hidden bg-background-200">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 69视频`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors"></div>
        <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded">
          {video.duration}
        </div>
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded whitespace-nowrap">
            {video.rating}
          </span>
        </div>
      </div>
      <h3 className="mt-2.5 text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1 font-heading">
        {video.title}
      </h3>
      <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
        <span>{video.categoryName}</span>
        <span>·</span>
        <span>{video.year}</span>
        <span>·</span>
        <span>{video.views}次播放</span>
      </div>
    </Link>
  );

  return (
    <>
      <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
                <i className="ri-fire-line text-accent-500 mr-2"></i>
                热门推荐
              </h2>
              <p className="mt-1 text-sm text-foreground-500">全网热播，大家都在看</p>
            </div>
            <Link
              to="/category/dianying"
              className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              查看更多 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {hotVideos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
                <i className="ri-sparkling-line text-primary-500 mr-2"></i>
                最新上线
              </h2>
              <p className="mt-1 text-sm text-foreground-500">新鲜出炉，不容错过</p>
            </div>
            <Link
              to="/category/duanju"
              className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              查看更多 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {newVideos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}